/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
import {clone, find, forEachObjIndexed, propEq} from 'ramda';

const List = styled.ul`
	flex: 0 1 ${({width}) => width ? width : '100%'};
	list-style: none outside;
	overflow: auto;
	${({isreport}) => isreport ? 'max-height: 250px;' : 'max-height: 400px;'}
`;

const ListItem = styled.li`
	font-size: 19px;
	color: ${({selected}) => selected ? '#43abf3' : '#3b3b3b'};
	padding-bottom: 15px;
	cursor: pointer;

	& + li {
		padding-top: 25px;;
		border-top: 1px solid #95989a;
	}
`;

class InputList extends React.Component {
    constructor(props) {
        super(props);
        const {randomWorksteps, displaycurrentstep} = this.props;

        const mergeme = x => x.value.selected = x.selected;
        let items = R.forEach(mergeme, clone(this.props.items));

        this.state = {
            items: R.pluck('value', clone(items)),
            currentTask: clone(this.props.currentTask),
            currentStep: clone(this.props.currentTask.step),
        };

        const setUsed = (item, key) => {
            if (displaycurrentstep !== undefined && displaycurrentstep === false){
                if (item.selectionorder <= this.state.currentStep) {
                    item.used = true;
                } else {
                    item.used = false;
                }
            }  else {
                if (item.selectionorder < this.state.currentStep) {
                    item.used = true;
                } else {
                    item.used = false;
                }
            }

        };


        if (this.state.currentTask.status === 'failed') {
            forEachObjIndexed((item, key) => item.used = false, this.state.items);
        } else if (this.props.isreport) {
            forEachObjIndexed((item, key) => item.used = false, this.state.items);
        } else {
            if (randomWorksteps === false) {
                forEachObjIndexed(setUsed, this.state.items);
            } else {
                forEachObjIndexed((item, key) => item.used = false, this.state.items);
            }
        }

    }

    selectItem = (itemIndex) => {

        const {items} = this.state;
        const selectedItem = find(propEq('selected', true))(items);
        const item = items.filter(item => item.used === false)[itemIndex];

        if (selectedItem) {
            selectedItem.selected = false;
        }

        item.selected = true;

        this.props.handleClick(item);
        this.setState({items});
    };

    render() {
        const {isreport, width, selectedSize = null} = this.props;

        return (
            <List width={width} isreport={isreport}>
                {this.state.items.filter(item => item.used === false).map((item, index) => (
                    <ListItem
                        key={`list-item-${index}-${item.selectionorder}`}
                        onClick={() => this.selectItem(index)}
                        selected={item.selected}
                        className={`${item.selected ? 'selected' : ''}`}
                        selectedSize={selectedSize}
                        used={item.used}
                    >
                        {item.label} - {item.name}
                    </ListItem>

                ))}
            </List>
        )
    }
}

export default InputList;



// WEBPACK FOOTER //
// ./src/components/general/input-list.js